export default "__VITE_ASSET__Dyuc1rnE__"